import React from "react"
import Dots from "./Dots/Dots"

import { Container, Cube, Content, BackgroundDiv } from "./ItemStyled"

export default function Item({
  children,
  text,
  number,
  background,
  color,
  dotBackground,
  dotInactiveBackground,
  dotShadow,
  activated,
  numberColor,
  hasDot,
  currency,
  winner,
}: any) {
  return (
    <Container color={color} winner={winner}>
      <BackgroundDiv background={background} />
      <Cube>{children}</Cube>
      <Content
        text={text}
        number={number[currency]}
        numberColor={numberColor}
        currency={currency}
      />
      {hasDot && (
        <Dots
          activated={activated}
          background={dotBackground}
          inactiveBackground={dotInactiveBackground}
          shadow={dotShadow}
        />
      )}
    </Container>
  )
}
